uniform vec3 uBaseColor;
uniform float uSize;
uniform float uTime;
uniform float uStep;
uniform float uStepRange;
uniform float uBaseColorPower;

varying vec2 vUv;

void main() {
  float opacity = pow(sin((vUv.x + uTime) * (1. / uSize)), 2.);
  opacity = smoothstep(uStep - uStepRange, uStep + uStepRange, opacity);
  gl_FragColor = vec4(uBaseColor * uBaseColorPower, opacity);
}